/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Learn_Blockscount1Inputs */

const zh_learn_blockscount1 = /** @type {(inputs: Learn_Blockscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 个题块`)
};

const en_learn_blockscount1 = /** @type {(inputs: Learn_Blockscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} blocks`)
};

const es_learn_blockscount1 = /** @type {(inputs: Learn_Blockscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} bloques`)
};

/**
* | output |
* | --- |
* | "{count} blocks" |
*
* @param {Learn_Blockscount1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_blockscount1 = /** @type {((inputs: Learn_Blockscount1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Blockscount1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_blockscount1(inputs)
	if (locale === "en") return en_learn_blockscount1(inputs)
	return es_learn_blockscount1(inputs)
});
export { learn_blockscount1 as "learn_blocksCount" }